import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-service-navigation/jb-service-navigation.css.ts
var jb_service_navigation_css_default = i`.service-navigation{align-self:center;display:var(--display, flex);font-size:0;gap:var(--spacing-m);justify-content:center;opacity:1;text-decoration:none;transition:opacity .35s ease-in-out .1s}.service-navigation__bottom-links{margin-bottom:90px;margin-top:40px;text-align:center}@media(orientation: landscape){.service-navigation__bottom-links--second-level{margin-bottom:70px}}.service-navigation--hidden{opacity:0}.service-navigation--hide-all-except-first ::slotted(jb-service-navigation-item:nth-child(n+2)){display:none}.service-navigation--hide-first ::slotted(jb-service-navigation-item:first-child){display:none}.service-navigation--hide-all ::slotted(jb-service-navigation-item){display:none}`;

export {
  jb_service_navigation_css_default
};
